<template>
    <main class="flex flex-col container mx-auto h-screen">
        <section class="my-auto ">
            <img class="mx-auto" src="@/assets/images/weentregas/full-logo-purple.png" width="200px" alt="">
            <div class=" max-w-xs mt-10 mx-auto my-auto w-full">
                <form class="bg-white rounded px-8 pt-6 pb-8 mb-4 largura" @submit.prevent="logar">
                    <div class="mb-4">
                        <label class="block mb-1 gray-wdc text-sm" for="username">
                            E-MAIL
                        </label>
                        <input v-validate="'required'" v-model="dados.email" class="font-semibold poppins text-base appearance-none border rounded w-full py-2 px-3 text-gray-900  focus:outline-none focus:shadow-outline"
                               id="username" type="text" placeholder="Digite seu email" value="Digite seu email">
                    </div>
                    <div class="mb-6">
                        <label class="block mb-1 gray-wdc text-sm" for="password">
                            TOKEN DA ORDEM:
                        </label>
                        <input v-validate="'required'" v-model="dados.token" class="font-semibold poppins text-base appearance-none border rounded w-full py-2 px-3 text-gray-900  focus:outline-none focus:shadow-outline"
                               id="password" type="text" placeholder="TOKEN" value="TOKEN">
                    </div>
                    <div class="flex items-center justify-between">
                        <button class="dados-btn hover:bg-blue-700 text-white font-bold py-2 px-4 rounded w-full h-14 Arial text-2xl" type="submit">
                            Entrar
                        </button>
                    </div>
                </form>
            </div>
        </section>
    </main>
</template>

<script>
    import moduleWeentrega from "../../store/weentrega/moduleWeentrega";

    export default {
        name: "Login",
        data() {
            return {
                active1: true,
                showlogin: false,
                isHidden: true,
                isHiddenemail: true,
                isHiddensenha: true,
                active2: false,
                dados: {
                    email: '',
                    token: '',
                },
                toastCount: 0,
                toastCount2: 0,
            }
        },
        created() {
            if (!moduleWeentrega.isRegistered) {
                this.$store.registerModule("weentrega", moduleWeentrega);
                moduleWeentrega.isRegistered = true;
            }
        },
        methods: {
            seguir() {
                if (this.email != '') {
                    this.active1 = false;
                    this.active2 = true;
                } else {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'E-mail inválido',
                        text: 'Digite um e-mail válido'
                    })
                }
            },

            logar() {
                this.$store.dispatch("weentrega/login", this.dados).then((response) => {
                    this.user = response.data;
                    this.$router.push({name: 'inicio'})
                }).catch(() => {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Usuário ou senha incorreto',
                        text: 'Verifique se os dados foram digitados corretamente'
                    })
                });
            }
        }
    }
</script>
